import {
  Box,
  Container,
  Grid,
  Typography
} from "@mui/material";
import Divider from "@mui/material/Divider";
import React from "react";
import CommonStyles from "../common/CommonStyles";
import SettingsControl from "../common2/SettingsControl";
const packageData = require('../../../package.json');

const About: React.FC = () => {
  const classes = CommonStyles();
  
  
 
  return (
    <>
      <Container className={`${classes.ptsm2} , ${classes.mx0}`}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={2} className={classes.preLoginControls}>
            <SettingsControl />
          </Grid>

          <Grid item md={8} className={classes.brdrLeft}>
            <Box className={classes.whiteBox}>
              <Box className={`${classes.row} ${classes.justifyBetween}`}>
                <Typography
                  className={classes.themeColorTxt}
                  variant="body2"
                  display="block"
                  gutterBottom
                >
                  About
                </Typography>
                {/* <FormControl component="fieldset" variant="standard">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={MFA}
                          name="MFA"
                          onChange={() => setMFA(!MFA)}
                        />
                      }
                      label="Enable Two-factor Authentication"
                    />
                  </FormGroup>
                </FormControl> */}
              </Box>
              <Divider />
              <br />
              <Box>
                <Grid container className={classes.upgradePopup} spacing={3}>
                  <Grid item xs={12}>
                    
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container className="" spacing={1}>
                      <Grid item md={6} xs={12}>
                        <Box className="pl-20p mb2">
                          <Typography
                            className={classes.themeColorTxt}
                            variant="body2"
                          >
                            Version : <b>{packageData.version}</b>
                          </Typography>
                        </Box>
                      </Grid>
                      
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
export default About;
